import React, { useEffect, useRef } from 'react'
import { useUpdateBazaarvoiceStyles } from '../../hooks/useUpdateBazaarvoiceStyles'
import { isLdFlagInABTest } from '../../utils/abTestsUtils'
import { useAppearedInView } from '../../utils/useAppearedInView'
import { SHOW_EMPTY_REVIEWS } from '../../../../../common/constants'

const BazaarvoiceContainer = ({ productId, productsTogglesToDataLayer }) => {
  const bvContainerRef = useRef()
  useUpdateBazaarvoiceStyles()
  const inView = useAppearedInView(bvContainerRef)
  const handleBVReviewsClick = () => {
    if (isLdFlagInABTest(SHOW_EMPTY_REVIEWS, productsTogglesToDataLayer)) {
      window?.dataLayer?.push({
        event: 'ldFlaggedFeature',
        ldFlag: SHOW_EMPTY_REVIEWS,
        ldFlagStatus: true,
        ldVariation: 'main-reviews-clicked'
      })
    }
  }
  useEffect(() => {
    if (inView && isLdFlagInABTest(SHOW_EMPTY_REVIEWS, productsTogglesToDataLayer)) {
      window?.dataLayer?.push({
        event: 'ldFlaggedFeature',
        ldFlag: SHOW_EMPTY_REVIEWS,
        ldFlagStatus: true,
        ldVariation: 'main-reviews-shown'
      })
    }
  }, [productsTogglesToDataLayer, inView, bvContainerRef])

  return (
    <div ref={bvContainerRef} onClick={handleBVReviewsClick}>
      <div data-bv-show='reviews' data-bv-product-id={productId} className='bv-reviews' />
      <div data-bv-show='questions' data-bv-product-id={productId} />
    </div>
  )
}
export default React.memo(BazaarvoiceContainer)
